import { Auth } from "aws-amplify";
import { useCallback } from "react";

export function useLogout() {
  return useCallback(async () => {
    await Auth.signOut();
    window.location.reload();
  }, []);
}
